import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight } from "@phosphor-icons/react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { api } from "../lib/api";

export default function Insights() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/insights").then((r) => setItems(r.data || [])).catch(() => setItems([]));
  }, []);

  return (
    <div data-testid="insights-page" className="bg-[#050505] text-white min-h-screen">
      <Header />
      <main>
        <section className="relative pt-32 md:pt-40 pb-16 grid-bg overflow-hidden">
          <div className="absolute inset-0 beam pointer-events-none" />
          <div className="relative mx-auto max-w-[1440px] px-6 md:px-10">
            <div className="font-mono text-[11px] tracking-[0.28em] text-cy uppercase mb-6 rise d-1">
              / Insights · Field Notes
            </div>
            <h1
              data-testid="insights-headline"
              className="font-display text-5xl md:text-7xl font-black tracking-[-0.03em] leading-[0.95] text-white max-w-4xl rise d-2"
            >
              Signals from the
              <span className="block text-cy">Bangalore floor.</span>
            </h1>
            <p className="mt-8 max-w-2xl text-zinc-400 text-base md:text-lg rise d-3">
              Short, opinionated notes from the work — each one anchored by a caselet you&apos;ve
              probably seen play out in your own building.
            </p>
          </div>
        </section>

        <section className="bg-[#070709] border-t border-ink-600">
          <div className="mx-auto max-w-[1440px] px-6 md:px-10 py-16 md:py-24">
            {items.length === 0 && (
              <div className="py-10 text-zinc-500 text-sm">Loading field notes…</div>
            )}
            <div className="border-t border-ink-500">
              {items.map((p) => (
                <article
                  key={p.id}
                  id={p.slug}
                  data-testid={`insight-${p.slug}`}
                  className="group border-b border-ink-500 py-8 md:py-12 hover:bg-white/[0.02] transition-colors"
                >
                  <div className="grid grid-cols-12 gap-6 md:gap-10 px-2 md:px-4">
                    <div className="col-span-12 md:col-span-3">
                      <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-cy">
                        {p.category}
                      </div>
                      <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-zinc-500 mt-2">
                        {p.published_at}
                      </div>
                      <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-zinc-600 mt-1">
                        {p.read_time}
                      </div>
                    </div>

                    <div className="col-span-12 md:col-span-9">
                      <h2 className="font-display text-xl md:text-2xl font-bold text-white tracking-tight leading-snug max-w-3xl">
                        {p.title}
                      </h2>
                      {p.caselet && (
                        <div
                          data-testid={`insight-caselet-${p.slug}`}
                          className="mt-5 border-l-2 border-cy pl-5 py-1 max-w-3xl"
                        >
                          <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-cy mb-2">
                            Caselet · from the floor
                          </div>
                          <p className="text-sm md:text-base text-zinc-300 italic leading-relaxed">
                            {p.caselet}
                          </p>
                        </div>
                      )}
                      <p className="mt-5 text-sm md:text-base text-zinc-400 max-w-3xl leading-relaxed">
                        {p.excerpt}
                      </p>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section className="bg-cy text-ink">
          <div className="mx-auto max-w-[1440px] px-6 md:px-10 py-16 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
            <h2 className="font-display text-3xl md:text-4xl font-black tracking-tight leading-tight">
              See your own signal in these?
            </h2>
            <Link
              to="/contact"
              data-testid="insights-cta"
              className="inline-flex items-center gap-3 bg-ink text-cy px-8 py-4 text-sm font-semibold hover:bg-white hover:text-ink transition-colors"
            >
              Start a consult <ArrowUpRight size={14} weight="bold" />
            </Link>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
